import React, { useState, useContext, useRef } from "react";
import { useMsal } from "@azure/msal-react";

import { Persona, PersonaSize, ContextualMenu } from "@fluentui/react";

import { MenuContext } from "./Contexts/MenuContext";
import { handleLogout } from "./Functions/Handlers";

export const Person = () => {
  const { instance, accounts } = useMsal();
  const [menuContext] = useContext(MenuContext);

  const linkRef = useRef(null);
  const [showContextualMenu, setShowContextualMenu] = useState(false);

  return (
    <div ref={linkRef} onClick={() => setShowContextualMenu(true)}>
      <Persona
        text={accounts[0]?.name}
        secondaryText={accounts[0]?.username}
        size={PersonaSize.size40}
        hidePersonaDetails={false}
        imageUrl={menuContext.avatar}
        imageShouldStartVisible={true}
        imageAlt={accounts[0]?.name}
        styles={{ root: { cursor: "pointer" } }}
      />
      <ContextualMenu
        items={[
          {
            key: "logout",
            text: "Logout",
            iconProps: { iconName: "Leave" },
            onClick: () => handleLogout(instance, accounts),
          },
        ]}
        hidden={!showContextualMenu}
        target={linkRef}
        onItemClick={() => setShowContextualMenu(false)}
        onDismiss={() => setShowContextualMenu(false)}
      />
    </div>
  );
};
